// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"436":"488f0dafc1fd1be9","2888":"7a9cf7ce108f59ce"}[chunkId] + ".css";
};